import React, { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import Button from '@mui/material/Button';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { clsx } from 'clsx';
// Components
import Text from '../text';
// Resources
import useGlobalStyles from '../hook/useGlobalStyles';

interface ArrowButtonProps {
    id?: string;
    title: string;
    subtitle?: string;
    subtitleView?: React.ReactNode;
    onClick?: () => void;
    pathRoute?: string;
    className?: string;
}

const ArrowButton: FC<ArrowButtonProps> = ({
    title,
    subtitle,
    subtitleView,
    onClick,
    pathRoute,
    className,
    ...rest
}): ReactElement => {
    const classes = useStyles();
    const globalClasses = useGlobalStyles();

    const buttonProps = pathRoute ? { component: Link, to: pathRoute } : { onClick };

    return (
        <Button
            {...buttonProps}
            endIcon={<ArrowForwardIosIcon className={classes.icon} />}
            {...rest}
            className={clsx(classes.arrowButtonRoot, className)}
        >
            {subtitleView ? (
                <div className={classes.customView}>
                    <Text.Body1 text={title} />
                    {subtitleView}
                </div>
            ) : (
                <>
                    <Text.Body1 text={title} />
                    {subtitle && <Text.Overline text={subtitle} marginLeft={1} />}
                </>
            )}
            <span className={globalClasses.flex} />
        </Button>
    );
};

const useStyles = makeStyles(() =>
    createStyles({
        arrowButtonRoot: {
            width: 'inherit',
            justifyContent: 'left',
            textAlign: 'initial',
            '&:hover': {
                textDecoration: 'none',
                backgroundColor: 'transparent',
            },
        },
        icon: {
            color: 'inherit',
            fontSize: '16px!important',
        },
        customView: { flexDirection: 'column' },
    }),
);

export default ArrowButton;
